import React from 'react'
import './Pages.sass'
import PagesList from './PagesList'
import PagesManager from './PagesManager'

function Pages() {
  return (
    <div className="Pages">
      <PagesList onClickPath={'/settings/pages'} routerIdName="pageId" />
      <PagesManager />
    </div>
  )
}

export default Pages
